<template>
  <notes v-if="!loading" @returnToOverview='returnToOverview'/>
</template>

<script>
import Notes from '@/components/Notes';
import { mapState } from 'vuex';
import ACTIONS from '@/store/storeActions';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);

export default {
  name: 'NotesPage',
  components: {
    Notes
  },
  computed: {
    ...mapState({
      currentExerciseId: (state) => state.run.currentExerciseId,
    }),
  },
  data: () => ({
    loading: true,
  }),
  methods: {
    returnToOverview() {
      const self = this;
      self.$router.push('overview');
    }
  },
  mounted() {
    if (!this.currentExerciseId) {
      this.$router.push('overview');
      this.$store.dispatch(ACTIONS.SET_SNACKBAR, { text: this.$i18n.t('Errors.noExerciseSelected'), color: 'error' } );
    }
    this.loading = false;
  }
}
</script>

<style scoped>

</style>
